var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{class:`${!_vm.normalSize ? 'mr-1' : ''} ${_vm.oneSize ? 'oneSize' : ''}`,attrs:{"label":"","small":!_vm.normalSize,"outlined":!_vm.backgroundColor,"color":_vm.backgroundColor ? _vm.backgroundColor : _vm.color,"text-color":_vm.backgroundColor ? _vm.color : _vm.color,"ripple":!_vm.noRipple}},[_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }